
export class Compliance {
    isCompliant: boolean = false;
    compliant: string = '';
    haulContract: string = '';
    safetyRating: string = '';
    insurance: string = '';
    insuranceExpireDate: string = '';
    lastUpdated: string = '';
}